import React from 'react';

import PolicyResult from 'components/atoms/policy_result';

const PolicyError: React.FC = () => (
  <PolicyResult
    variant="error"
    icon={<i className="material-icons">close</i>}
    title="Algo deu errado"
    source="Tela Erro na Apólice ConlicitaSeg Only"
  >
    Não foi possível processar sua solicitação. Fale com um de{' '}
    <a href="/conlicitaseg/contato" target="_blank" rel="noopener noreferrer">
      nossos especialistas
    </a>
    .
  </PolicyResult>
);

export default PolicyError;
